import React from 'react';
import {Container} from 'containers/types';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<SubNavigationProps & Container> {
  render() {
    return <div className="SubNavigation colab-sidepadding-2 colab-centered" />;
  }
}

export default SubNavigation;
